import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

const CityTour = () => {
    const tourItems = [
        {
            title: "Lalbagh Botanical Garden",
            description:
                "Start the day at one of Bangalore's most famous gardens, known for its greenery, calm environment, and scenic beauty.",
            image: "/assets/garden.jpg",
        },
        {
            title: "Cubbon Park",
            description:
                "Relax and enjoy a walk through Cubbon Park, located in the heart of the city and surrounded by historic buildings.",
            image: "/assets/park.jpg",
        },
        {
            title: "Vidhana Soudha (Outside View)",
            description:
                "Visit Bangalore's most iconic landmark for photos and a quick stop to admire its grand architecture.",
            image: "/assets/vidhana.jpg",
        },
        {
            title: "Bangalore Palace",
            description:
                "Explore Bangalore Palace and experience the city's royal history and elegant architecture.",
            image: "/assets/place.jpg",
        },
        {
            title: "Commercial Street / MG Road",
            description:
                "End the tour with shopping and local food experiences in one of Bangalore's busiest areas.",
            image: "/assets/road.jpg",
        },
    ];

    return (
        <div className="min-h-screen  py-12">
            <div className="container mx-auto px-4">
                <h1 className="text-4xl font-bold text-center mb-12 text-gray-800">
                    Saturday City Tour
                </h1>
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{ clickable: true }}
                    breakpoints={{
                        640: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        },
                    }}
                    className="pb-12"
                >
                    {tourItems.map((item, index) => (
                        <SwiperSlide key={index}>
                            <Link
                                to="/city-tour-details"
                                className="block h-full"
                            >
                                <div className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300 h-full">
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        className="w-full h-48 object-cover"
                                    />
                                    <div className="p-6">
                                        <h2 className="text-xl font-semibold mb-3 text-gray-800">
                                            {item.title}
                                        </h2>
                                        <p className="text-gray-600">
                                            {item.description}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CityTour;
